
/* injects from baggage-loader */

'use strict';

import { assign, findIndex } from 'lodash';

export default function (app) {
  app
    .factory('Session', SessionFactory);

  function SessionFactory($state, $rootScope) {
    'ngInject';

    let self = {
      enabled: true
    };

    self.$state = $state;

    self.create = function(user){
      let updates = {};
      
      

      updates = {
        user: {
          name: user.name,
          avatar: user.avatar
        },
        trophies: [
          {
            name: 'p1',
            collected: false
          },
          {
            name: 'p2',
            collected: false
          },
          {
            name: 'p3',
            collected: false
          },
          {
            name: 'p4',
            collected: false
          },
          {
            name: 'p5',
            collected: false
          },
          {
            name: 'p6',
            collected: false
          }
        ],
        stages:[
          {
            name: "Stage 1",
            route: "main.stage-one",
            completed: false,
            totalCompleted: 0
          },
          {
            name: "Stage 2",
            route: "main.stage-two",
            completed: false,
            totalCompleted: 0
          },
          {
            name: "Stage 3",
            route: "main.stage-three",
            completed: false,
            totalCompleted: 0
          },
          {
            name: "Stage 4",
            route: "main.stage-four",
            completed: false,
            totalCompleted: 0
          },
          {
            name: "Stage 5",
            route: "main.stage-fifth",
            completed: false,
            totalCompleted: 0
          },
          {
            name: "Stage 6",
            route: "main.stage-sixth",
            completed: false,
            totalCompleted: 0
          },
          {
            name: "Stage 7",
            route: "main.stage-seventh",
            completed: false,
            totalCompleted: 0
          }
        ]
      };

      // set shared currentUser
      $rootScope.$currentUser = user

      return sessionStorage.$session = JSON.stringify(updates);
    }

    self.getTaskOne = function(){
      let stages = self.get().stages;

      let stagesComplete = 0;

        

        for (let i = 0; i < 3; i++) {
            if(stages[i].completed){
                stagesComplete++;
            }
        }

        return stagesComplete;
    }
    
    self.save = function(updates, all){
      if(all){
        sessionStorage.$session = JSON.stringify(updates);
      } else{
        sessionStorage.$session = JSON.stringify({ user: self.get().user, stages: updates.stages, trophies: updates.trophies});
      }
      return sessionStorage.$session;
    }

    self.updateStage = function(name, updates){
      let session = self.get();
      let currentStageIndex = findIndex(session.stages, stage => stage.name === name)

      if(currentStageIndex < 0) return false;

      let stage = session.stages[currentStageIndex];

      session.stages[currentStageIndex] = assign(stage, updates);

      self.save(session);
    }

    self.get = function(){
      try {
        return JSON.parse(sessionStorage.$session);        
      } catch (error) {
        return {};
      }
    }

    self.destroy = function(){
      delete sessionStorage.$session;
      return $state.go('login');
    }

    return self;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/session.factory.js